import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng/errorBoundary';
import Slide from '@ifeng/ui_pc_slides';
import styles from './index.css';
import { rel } from '../../../../../utils/rel';
import { formatUrl } from '@ifeng/public_method';
import { handleSlideData } from '../../../../../utils/handleSlideData';

const MatchInfo = errorBoundary(
    class extends PureComponent {
        static propTypes = {
            content: PropTypes.array,
            mode: PropTypes.string,
        };

        renderMatchBox = (item, index) => {
            return (
                <li key={index}>
                    <div className={styles.matchnav_cell}>
                        <div className={styles.matchnav_classify}>
                            <em>{item.matchName}</em>
                            {item.link ? (
                                <div className={`${styles.matchnav_state} ${styles.fr}`}>
                                    <a href={formatUrl(item.link)} target="_blank" rel={rel}>
                                        战报
                                    </a>
                                </div>
                            ) : null}
                        </div>
                        <div className={styles.matchnav_info}>
                            <div className={styles.matchnav_team}>
                                <div className={styles.matchnav_logo}>
                                    <img src={item.homeImg} width="100%" />
                                </div>
                                <div className={styles.matchnav_name}>{item.homeName}</div>
                                <div className={item.date ? styles.matchnav_time : styles.matchnav_score}>
                                    {item.date ? item.date : item.homeScore}
                                </div>
                            </div>
                            <div className={styles.matchnav_team}>
                                <div className={styles.matchnav_logo}>
                                    <img src={item.awayImg} width="100%" />
                                </div>
                                <div className={styles.matchnav_name}>{item.awayName}</div>
                                <div className={item.date ? styles.matchnav_time : styles.matchnav_score}>
                                    {item.time ? item.time : item.awayScore}
                                </div>
                            </div>
                        </div>
                    </div>
                </li>
            );
        };

        renderSlider = eachFream => {
            return <ul>{eachFream.map((item, index) => this.renderMatchBox(item, index))}</ul>;
        };

        renderResponseBox = () => {
            const { content, mode } = this.props;

            if (mode === 'wide') {
                return <ul>{content.map((item, index) => this.renderMatchBox(item, index))}</ul>;
            } else {
                const handleData = handleSlideData(content);

                const sliderConfig = {
                    sliderTmpl: this.renderSlider,
                    autoplay: false,
                    dots: false,
                    arrows: true,
                };

                return <Slide content={handleData} config={sliderConfig} />;
            }
        };

        render() {
            const { mode } = this.props;

            return (
                <div className={mode === 'wide' ? styles.dm_more_02 : styles.dm_more_01}>
                    {this.renderResponseBox()}
                </div>
            );
        }
    },
);

export { MatchInfo };
export default MatchInfo;
